import React, { useState } from "react";
import "./ContactUs.css";
import HomeHeader from "../../components/header/HomeHeader";
import CommonFooter from "../../components/footer/CommonFooter";
import Breadcrumb from "../../components/breadcrumb";
import CommonButton from "../../components/button/CommonButton";
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaFacebookF, FaInstagram, FaYoutube,FaInfo
} from "react-icons/fa";
import { IoIosPin} from "react-icons/io";
import { imagePath } from "../../constants/imagePath";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    contactNumber: "",
    userType: "Wholesaler",
    subject: "",
    message: ""
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log("Form submitted:", formData);
    // You can add API call here
  };

  return (
    <div className="contact-us">
      <HomeHeader />
      <Breadcrumb
        items={[
          {
            label: "Home",
            path: "/",
          },
          {
            label: "Contact Us",
            isActive: true,
          },
        ]}
      />
      <main className="contact-us__main">
        <div className="contact-us__container">
          <div className="contact-us__content">
            <div className="contact-us__left">
              <h2 className="contact-us__section-title">Other Ways To Connect</h2>
              
              <div className="contact-us__info-cards">
                <div className="contact-us__info-card">
                  <div className="contact-us__info-icon">
                    <FaPhone />
                  </div>
                  <div className="contact-us__info-content">
                    <h3 className="contact-us__info-label">Contact</h3>
                    <p className="contact-us__info-text">+91 9016501095</p>
                  </div>
                </div>

                <div className="contact-us__info-card">
                  <div className="contact-us__info-icon">
                    <FaEnvelope />
                  </div>
                  <div className="contact-us__info-content">
                    <h3 className="contact-us__info-label">Email</h3>
                    <p className="contact-us__info-text">contact@codeinfoway.com</p>
                  </div>
                </div>
                <div className="contact-us__info-card">
                  <div className="contact-us__info-icon">
                    <IoIosPin size={25}/>
                  </div>
                  <div className="contact-us__info-content">
                    <h3 className="contact-us__info-label">Address</h3>
                    <p className="contact-us__info-text">Shop No.314, Polaris Mall, Near Reshma Chowk, Puna BRTS Canal Road, Punagam SURAT, GUJARAT, India 395010</p>
                  </div>
                </div>
                <div className="contact-us__info-card">
                  <div className="contact-us__info-icon">
                    <FaInfo />
                  </div>
                  <div className="contact-us__info-content">
                  <p className="contact-us__info-text">This our official support mail-id and WhatsApp number if you need any kind of help please contact here we revert you in 24 working hours. and for Exchange proccess please do only WhatsApp text in our this number.</p>
                  </div>
                </div>
              </div>

              {/* <div className="contact-us__full-map-section">
                <h2 className="contact-us__section-title">Find Us On Google Maps</h2>
                <div className="contact-us__map-card">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3671.3328057994495!2d72.67052777520074!3d23.04825727915575!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e876284960a09%3A0x2cc31e23fd49bcb4!2sCodeInfoWay!5e0!3m2!1sen!2sin!4v1764909098882!5m2!1sen!2sin"
                    width="100%"
                    height="400"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Codeinfoway"
                  ></iframe>
                </div>
              </div> */}

            </div>

            {/* <div className="contact-us__right">
              <h2 className="contact-us__section-title">Get In Touch With Us</h2>
              
              <form className="contact-us__form" onSubmit={handleSubmit}>
                <div className="contact-us__form-group">
                  <label htmlFor="fullName" className="contact-us__form-label">
                    Full Name*
                  </label>
                  <input
                    type="text"
                    id="fullName"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    className="contact-us__form-input"
                    placeholder="Enter Full Name"
                    required
                  />
                </div>

                <div className="contact-us__form-row">
                  <div className="contact-us__form-group">
                    <label htmlFor="email" className="contact-us__form-label">
                      Email*
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      className="contact-us__form-input"
                      placeholder="Enter Email Address"
                      required
                    />
                  </div>

                  <div className="contact-us__form-group">
                    <label htmlFor="contactNumber" className="contact-us__form-label">
                      Contact Number*
                    </label>
                    <input
                      type="tel"
                      id="contactNumber"
                      name="contactNumber"
                      value={formData.contactNumber}
                      onChange={handleInputChange}
                      className="contact-us__form-input"
                      placeholder="Enter Contact Number"
                      required
                    />
                  </div>
                </div>

                <div className="contact-us__form-group">
                  <label htmlFor="userType" className="contact-us__form-label">
                    User Type*
                  </label>
                  <select
                    id="userType"
                    name="userType"
                    value={formData.userType}
                    onChange={handleInputChange}
                    className="contact-us__form-select"
                    required
                  >
                    <option value="wholesaler">Wholesaler</option>
                    <option value="retailer">Retailer</option>
                  </select>
                </div>

                <div className="contact-us__form-group">
                  <label htmlFor="subject" className="contact-us__form-label">
                    Subject*
                  </label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleInputChange}
                    className="contact-us__form-input"
                    placeholder="Enter Subject"
                    required
                  />
                </div>

                <div className="contact-us__form-group">
                  <label htmlFor="message" className="contact-us__form-label">
                    Message
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    className="contact-us__form-textarea"
                    placeholder="Enter Message..."
                    rows="4"
                  />
                </div>

                <div className="contact-us__form-submit">
                  <CommonButton
                    type="submit"
                    title="Submit"
                    customClassName="contact-us__submit-btn"
                  />
                </div>
              </form>
            </div> */}
          </div>

          {/* Full-width Google Maps section */}
        </div>
      </main>

      <CommonFooter />
    </div>
  );
};

export default ContactUs;
